// extracted by mini-css-extract-plugin
module.exports = {"list__header":"_5D3n3y2c","list__counter":"_5D2Oit3a","list__title":"_5D1BcT0E","list__separator":"_5D2LB_QT","list--1":"_5D3Bj-XF","scroll-list":"_5D2snNkc","list-ul":"_5D3-g6ET"};